import ProfileSettings from '@Services/ProfileSettings';
import { profileSettingsSetIsLoadingReducerType } from './ProfileSettingsConstants';

export function setIsLoading(isLoading) {
  return {
    type: profileSettingsSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export const init = () => async (dispatch) => {
  dispatch(setIsLoading(true));
  const isLoaded = await ProfileSettings.loadProfileSettingsInfo();
  dispatch(setIsLoading(!isLoaded));
  return isLoaded;
};
